module.exports = __webpack_public_path__ + "static/img/006.d4b7e7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-eplus/006.png
// module id = MRG4
// module chunks = 1